import React from 'react';
import { ManageParameterProps } from 'ducks/types/prop-types';
import { ManageParameterContextProvider } from 'modals/parameters/context/ManageParameterContext';
import { ManageParameterModal } from 'modals/parameters/ManageParameterModal';

export const ManageParameter = (props: ManageParameterProps) => {
  return (
    <ManageParameterContextProvider>
      <ManageParameterModal {...props} />
    </ManageParameterContextProvider>
  );
};
